/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { LegacyRef, useEffect, useMemo, useRef, useState } from "react";
import sass from "pages/StepPages/StepFour/IndexPage/indexPage.module.sass";
import cn from "classnames";
import { IThreadList } from "pages/StepPages/StepFour/models/threadModel";
import { ReactComponent as ArrowTop } from "images/ArrowsTop.svg";
import Tooltip from "components-new/Tooltip";
import { useNavigate } from "react-router-dom";
import ConfirmNavigate from "components/ConfirmNavigate";
import { IOptionsSort } from "../IndexPage";

interface IColumnData {
	data: IThreadList[];
	stepOne: boolean | null;
	sort: (sort: IOptionsSort) => void;
	lastElement: React.MutableRefObject<HTMLElement | null>;
	scrollWrapper: React.MutableRefObject<HTMLElement | null>;
}
function getTopChord(arrAnchor: HTMLDivElement[]) {
	const arr: number[] = [];
	for (let i = 0; i < arrAnchor.length; i++) {
		arr.push(arrAnchor[i].getBoundingClientRect().top);
	}
	return arr;
}

const Helper = (data: IThreadList) => {
	const [flag, setFlag] = useState(false);
	return (
		<div className={sass.tooltip}>
			<div className={sass.block}>{data.name}</div>
			{!flag && (
				<div onClick={() => setFlag(true)} className={cn(sass.link, sass.more)}>
					Подробнее
				</div>
			)}
			{flag && (
				<div className={sass.hideWrapper}>
					<div className={sass.block}>
						<span className={sass.title}>Назначение</span>
						<div>
							{/*{data.purpose}*/}
							<span dangerouslySetInnerHTML={{ __html: data.purpose }} />
						</div>
					</div>
					<div className={sass.block}>
						<span className={sass.title}>Ответственный</span>
						<span className={sass.link}>
							{data.responsible.lastName} {data.responsible.firstName} {data.responsible.middleName}
						</span>
					</div>
				</div>
			)}
		</div>
	);
};

const Anchor: React.FC<{ fields: { [key: string]: any }[]; classAnchor: string }> = ({ fields, classAnchor }) => {
	return (
		<div className={cn(sass.anchor, classAnchor)}>
			{!!fields.length ? (
				fields.map((_: any, index) => (
					<div key={index} onClick={() => _.onClick()}>
						<ArrowTop />
						<span>{_.name}</span>
					</div>
				))
			) : (
				<div>
					<ArrowTop />
					<span>Прошли</span>
				</div>
			)}
		</div>
	);
};

const ColumnData: React.FC<IColumnData> = ({ data, stepOne, scrollWrapper, lastElement }) => {
	const navigate = useNavigate();
	const containerRef = useRef<HTMLDivElement | null>(null);

	const successRef = useRef<HTMLDivElement | null>(null);
	const loadRef = useRef<HTMLDivElement | null>(null);
	const emptyRef = useRef<HTMLDivElement | null>(null);
	const repeatebleRef = useRef<HTMLDivElement | null>(null);

	const [target, setTarget] = useState<string | undefined>();

	const [navigateModal, setNavigateModal] = useState(false);

	// const [flag, setFlag] = useState(false);
	const [object, setObject] = useState<Array<{ [key: string]: any }>>([]);
	const [scrollTop, setScrollTop] = useState(false);
	useEffect(() => {
		function scroll() {
			if (stepOne !== null) {
				let containerTop: number;
				if (containerRef.current) {
					containerTop = containerRef.current?.getBoundingClientRect().top as number;
					// || successRef.current || loadRef.current || emptyRef.current
					if (emptyRef.current) {
						const [emptyTop] = getTopChord([emptyRef.current!]);
						if (emptyTop < containerTop - 15) {
							// setFlag(true)
							setObject([
								{
									name: stepOne ? "Ожидают" : "Без расчета",
									onClick: () => {
										emptyRef.current?.scrollIntoView({ block: "start", behavior: "smooth" });
									},
								},
							]);
						} else {
							setObject([]);
							setScrollTop(false);
						}
					}
					if (loadRef.current) {
						const [loadTop] = getTopChord([loadRef.current]);
						if (loadTop < containerTop - 15) {
							setObject((prevState) => [
								...prevState,
								{
									name: stepOne ? "Сформировано" : "С расчетом",
									onClick: () => loadRef.current?.scrollIntoView({ block: "start", behavior: "smooth" }),
								},
							]);
						} else {
							setObject((prevState) => prevState.filter((_) => _.name !== (stepOne ? "Сформировано" : "С расчетом")));
						}
					}
					if (stepOne && successRef.current) {
						const [sucTop] = getTopChord([successRef.current]);
						if (sucTop < containerTop - 15) {
							setObject((prevState) => [
								...prevState,
								{
									name: "Получил",
									onClick: () => successRef.current?.scrollIntoView({ block: "start", behavior: "smooth" }),
								},
							]);
						} else {
							setObject((prevState) => prevState.filter((_) => _.name !== "Получил"));
						}
					}
					if (repeatebleRef.current) {
						const [repeatTop] = getTopChord([repeatebleRef.current]);
						if (repeatTop < containerTop - 15) {
							setObject((prevState) => [
								...prevState,
								{
									name: "Повторная",
									onClick: () => repeatebleRef.current?.scrollIntoView({ block: "start", behavior: "smooth" }),
								},
							]);
						} else {
							setObject((prevState) => prevState.filter((_) => _.name !== "Повторная"));
						}
					}
				}
			}
		}
		function wheel(e: WheelEvent & { wheelDeltaY: number }) {
			if (e.wheelDeltaY) {
				if (e.wheelDeltaY > 0) {
					setScrollTop(true);
				} else {
					setTimeout(() => {
						setScrollTop(false);
					}, 200);
				}
			}
		}

		const cont = containerRef.current;
		cont?.addEventListener("scroll", scroll);
		cont?.addEventListener("wheel", (e) => wheel(e as WheelEvent & { wheelDeltaY: number }));
		return () => {
			cont?.removeEventListener("scroll", scroll);
			cont?.removeEventListener("wheel", (e) => wheel(e as WheelEvent & { wheelDeltaY: number }));
		};
		//eslint-disable-next-line
	}, [stepOne]);
	console.log(data.length);
	const renderData = useMemo(() => {
		let finalList: any = {};
		if (stepOne !== null) {
			if (stepOne) {
				finalList = {
					existThread: {
						name: "Ожидает формирования модели угроз",
						ref: emptyRef,
						className: "",
						fields: [...data].filter((_) => !_.categoryExists && !_.threatExists && !_.repeatable),
					},
					finalThread: {
						name: "Модель угроз сформирована",
						ref: loadRef,
						className: sass["list_wrapper__item-allow"],
						fields: [...data].filter((_) => _.threatExists && !_.repeatable),
					},
					category: {
						name: "Объект получил категорию",
						ref: successRef,
						className: sass["list_wrapper__item-success"],
						fields: [...data].filter((_) => _.categoryExists && !_.repeatable),
					},
					repeatable: {
						name: "Повторное категорирование",
						ref: repeatebleRef,
						className: sass["list_wrapper__item-purple"],
						fields: [...data].filter((_) => _.repeatable),
					},
				};
			} else {
				finalList = {
					existThread: {
						name: "Расчет не производился",
						ref: emptyRef,
						className: sass["list_wrapper__item-allow"],
						fields: [...data].filter((_) => !_.damageExists && !_.repeatable),
					},
					finalThread: {
						name: "Расчет готов",
						ref: loadRef,
						className: sass["list_wrapper__item-success"],
						fields: [...data].filter((_) => _.damageExists && !_.repeatable),
					},
					repeatableThreat: {
						name: "Повторное категорирование",
						ref: repeatebleRef,
						className: sass["list_wrapper__item-purple"],
						fields: [...data].filter((_) => _.repeatable),
					},
				};
			}
		}
		let retArr = [];
		let finalListKey: keyof typeof finalList;
		for (finalListKey in finalList) {
			const elem: any = finalList[finalListKey];
			elem.fields.length &&
				retArr.push(
					<React.Fragment key={elem.name}>
						<p ref={elem.ref} className={sass.title}>
							{elem.name}
						</p>
						<div className={sass.list}>
							{elem.fields.map((_: IThreadList) => {
								return (
									<Tooltip key={_.id} menu={<Helper {..._} />} color={"themeWhite"} position={"bottom"}>
										<div
											key={_.id}
											onClick={() => {
												if (_.repeatable) {
													setTarget(stepOne ? `${_.id}` : `${_.id}${_.damageExists ? "/result" : ""}`);
													setNavigateModal(true);
												} else {
													stepOne
														? navigate(`thread/${_.id}/description`)
														: navigate(`calculate/${_.id}${_.damageExists ? "/result" : ""}`);
												}
											}}
											className={cn(sass["list_wrapper__item"], elem.className)}>
											<p className={sass.mute}>{_.code}</p>
											{stepOne ? (
												<p className={cn(sass.status, sass[`status-${_.status ? _.status.toLowerCase() : ""}`])}>
													{_.name}
												</p>
											) : (
												<p
													className={cn(
														sass.status,
														sass[`status-${_.damageStatus ? _.damageStatus.toLowerCase() : ""}`],
													)}>
													{_.name}
												</p>
											)}
										</div>
									</Tooltip>
								);
							})}
						</div>
					</React.Fragment>,
				);
		}
		return retArr;
		//eslint-disable-next-line
	}, [data, stepOne]);

	return (
		<div className={sass.wrapper} ref={scrollWrapper as LegacyRef<HTMLDivElement> | undefined}>
			<ConfirmNavigate
				subtitle={"Изменение данных может повлечь рассинхронизацию данных в системе"}
				url={stepOne ? `thread/${target}/description` : `calculate/${target}`}
				toggle={navigateModal}
				close={() => {
					setNavigateModal(false);
					setTarget(undefined);
				}}
			/>
			<Anchor classAnchor={sass[`anchor_${object.length && scrollTop}`]} fields={object} />
			<div data-comment-false={true} ref={containerRef} className={sass.list_wrapper}>
				{renderData}
				<div ref={lastElement as LegacyRef<HTMLDivElement> | undefined} />
			</div>
		</div>
	);
};

export default ColumnData;
